import {
    FETCH_ALL_BATTERIES_BEGAN,
    FETCH_ALL_BATTERIES_FAILED,
    FETCH_ALL_BATTERIES_SUCCESS
} from "../actionTypes/allBatteries";
import axios from "axios";
import * as API from "../../constants/api";
import {userIdSelector} from "../reducers/authReducer";


export const fetchAllBatteries = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: FETCH_ALL_BATTERIES_BEGAN
        })

        try {
            console.log('request begin ', API.getAllBatteries(userIdSelector(getState())))
            let response = await axios.get(API.getAllBatteries(userIdSelector(getState())), {headers: API.defaultHeaders})
            console.log('request end ', response)

            dispatch({
                type: FETCH_ALL_BATTERIES_SUCCESS,
                payload: response.data.batteries
            })

        }catch(error){
            dispatch({
                type: FETCH_ALL_BATTERIES_FAILED,
                payload: error
            })
        }
    }
}